import axios from '../utils/axios';

const SERVICE_URL = '/characteristics';

export const getCharacteristicsList = async (
    searchTerm,
    page,
    rowsPerPage,
    lastEvaluatedKey,
    sortAscending
) => {
    try {
        let response = await axios.post(
            `${SERVICE_URL}`
            , 
            { 
                searchTerm,
                page,
                rowsPerPage,
                lastEvaluatedKey,
                sortAscending
            }
        );
        return response.data;
    } catch (error) {
        return {
            items: [], 
            lastEvaluatedKey: null,
            count: 0
        };
    }
}

export const getCharacteristicAll = async () => {
    try {
        let response = await axios.get(`${SERVICE_URL}/all`)
        return response.data
    } catch (error) {
        return {
            characteristics: [],
            error
        };
    }
}

export const getCharacteristicsSearch = async (
    wordToSearch
) => {
    try {
        let response = await axios.post(`${SERVICE_URL}/search`, { wordToSearch });
        return response.data;
    } catch (error) {
        return {
            characteristics: [],
            error
        };
    }
}

export const getCharacteristicById = async (
    _id
) => {

    try {
        let response = await axios.post( `${SERVICE_URL}/id` , { id: _id } );
        return response.data;
    } catch (error) {
        return {
            error
        };
    }
}

export const getCharacteristicByIdList = async (
    _idList
) => {

    try {
        let response = await axios.post( `${SERVICE_URL}/idList` , { idList: _idList } );
        return response.data;
    } catch (error) {
        return {
            error
        };
    }
}

export const characteristicsCreate = async (formData) => {

    try {
        let response = await axios.post(`${SERVICE_URL}/create`, formData );
        return response.data;
    } catch (error) {
        return {
            result: false,
            message: error
        };
    }
}

export const characteristicsUpdate = async (formData) => {
    try {
        let response = await axios.put(`${SERVICE_URL}/update`, formData );
        return response.data;
    } catch (error) {
        return {
            result: false,
            message: error
        };
    }
}

export const characteristicsDelete = async (_id) => {
    try {
        let response = await axios.delete(`${SERVICE_URL}/delete?id=${_id}`);
        return response.data;
    } catch (error) {
        return {
            result: false,
            message: error
        };
    }
}